import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@monorepo/nova-ui';
import { TitleContainer } from '../styled';

/**
 * Chart Title Component
 *
 * Displays the chart title with proper typography and theming.
 */
export const ChartTitle: FC = () => {
  const { t } = useTranslation('performanceChart');

  return (
    <TitleContainer>
      <Typography
        variant="subtitle2"
        sx={(theme) => ({
          fontWeight: theme.typography.fontWeightMedium,
          color: theme.palette.text.primary,
        })}
      >
        {t('chart.header.title')}
      </Typography>
    </TitleContainer>
  );
};
